
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonInleftBottom100 as ObiThreewayAcuatorPistonInleftBottom100Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-inleft-bottom-100.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonInleftBottom100 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-inleft-bottom-100',
   elementClass: ObiThreewayAcuatorPistonInleftBottom100Element,
   events: {
     
   }
  });
 
 